import {onlineAppRootLoader} from '../../rankers/online_apps/components/online_app_root/online_app_root_loader';
onlineAppRootLoader();

document.dispatchEvent( new Event('OnlineAppLoaded') );